import { includes } from 'lodash';
import {
  ApiCallsFactory,
  LocalPersistence,
} from '../../../../../factories/index';
import { detailDataType } from './types';

// setting the dinamyc data

const setData = (
  type: string,
  index: number,
  value: string,
  data: string[],
  detailData: {
    [key: string]: number | string;
  }[],
  actionType: (a: string[]) => void
) => {
  let tempArray: string[] = [];
  tempArray = data;
  tempArray[index] = value;
  detailData[index][type] =
    value === '' ? '' : type === 'rulenumber' ? +value : value;
  actionType(tempArray);
  return true;
};

// getting the session data
const getSession = async () => {
  const get_session = new LocalPersistence('session');
  const session = await get_session.getSessionPersistence();
  return session;
};

// getCall
const getHelper = async (url: string) => {
  const currentSession = await getSession();
  const getService = new ApiCallsFactory(
    `${url}?supplier=${currentSession?.supplier}&propertyid=${currentSession?.propertyId}`,
    currentSession.token
  );
  const response = await getService.getData();
  return response;
};

// post call helper
const postHelper = async (url: string, body: object) => {
  try {
    const currentSession = await getSession();
    const postBody = {
      ...body,
      supplier: currentSession.supplier,
      propertyId: currentSession.propertyId,
    };
    const postService = new ApiCallsFactory(
      url,
      currentSession.token,
      postBody
    );
    const response = await postService.postData();
    return response;
  } catch (error: any) {
    return error;
  }
};

// post call
const post = async (detaildata: detailDataType) => {
  /* istanbul ignore next */
  try {
    const body = {
      supplier: '',
      propertyId: '',
      property: {
        policies: {
          extracharges: detaildata,
        },
      },
    };
    const response = await postHelper('/property/policies/extracharge', body);
    return response;
    // persisting the post data
  } catch (error: any) {
    throw new Error('Error posting the data');
  }
};

export { setData, post, getHelper };
